import apiClient from 'ps-components/lib/apiClient';

export const INITIALIZE_WITH_JOB = 'INITIALIZE_WITH_JOB',
  GET_SALARY_RANGES_START = 'GET_SALARY_RANGES_START',
  GET_SALARY_RANGES_SUCCESS = 'GET_SALARY_RANGES_SUCCESS',
  GET_SALARY_RANGES_ERROR = 'GET_SALARY_RANGES_ERROR',
  SET_CURRENCY = 'SET_CURRENCY',
  SET_SALARY_RANGE = 'SET_SALARY_RANGE',
  SET_CAREER_LEVEL = 'SET_CAREER_LEVEL',
  SET_JOB_FAMILY = 'SET_JOB_FAMILY',
  SET_JOB_TITLE = 'SET_JOB_TITLE',
  SAVE_ORG_JOB_SUCCESS = 'SAVE_ORG_JOB_SUCCESS',
  SAVE_ORG_JOB_START = 'SAVE_ORG_JOB_START',
  SAVE_ORG_JOB_FAILED = 'SAVE_ORG_JOB_FAILED',
  SET_ORG_JOB_CODE = 'SET_ORG_JOB_CODE',
  SET_JOB_DESCRIPTION = 'SET_JOB_DESCRIPTION',
  SET_YEARS_OF_EXPERIENCE = 'SET_YEARS_OF_EXPERIENCE',
  SET_TARGET_BASE_SALARY = 'SET_TARGET_BASE_SALARY',
  SET_TARGET_TOTAL_CASH = 'SET_TARGET_TOTAL_CASH',
  SET_TARGET_TOTAL_TARGET_CASH = 'SET_TARGET_TOTAL_TARGET_CASH',
  SET_TARGET_TOTAL_GUARANTEED_PAY = 'SET_TARGET_TOTAL_GUARANTEED_PAY',
  SET_TARGET_TOTAL_DIRECT = 'SET_TARGET_TOTAL_DIRECT',
  SET_FLSA_EXEMPT = 'SET_FLSA_EXEMPT',
  SET_EEO_JOB_GROUP = 'SET_EEO_JOB_GROUP',
  SET_EEO_JOB_CATEGORY = 'SET_EEO_JOB_CATEGORY',
  RESET_SAVE_JOB_PRICING_TO_INITIAL_STATE = 'RESET_SAVE_JOB_PRICING_TO_INITIAL_STATE',
  SET_ORG_JOB_CODE_KEY = 'SET_ORG_JOB_CODE_KEY',
  SET_ORG_JOB_DETAILS = 'SET_ORG_JOB_DETAILS',
  SET_SELECTED_USER_DEFINED_FIELDS = 'SET_SELECTED_USER_DEFINED_FIELDS',
  SET_SALARY_RANGE_MIN = 'SET_SALARY_RANGE_MIN',
  SET_SALARY_RANGE_MID = 'SET_SALARY_RANGE_MID',
  SET_SALARY_RANGE_MAX = 'SET_SALARY_RANGE_MAX';

export function initializeSaveJobPricingWithJob(job) {
  return dispatch => {
    dispatch({ type: RESET_SAVE_JOB_PRICING_TO_INITIAL_STATE });
    dispatch({ type: INITIALIZE_WITH_JOB, job });
  };
}

export function saveOrgJob(
  orgJobId,
  jobTitle,
  orgJobCode,
  orgJobCodeKey,
  currency,
  salaryStructure,
  salaryGrade,
  jobDescription,
  yearsOfExperience,
  skills,
  certs,
  targetTotalCash,
  targetBaseSalary,
  targetTotalTargetCash,
  targetTotalGuaranteedPay,
  targetTotalDirect,
  flsaExempt,
  eeoJobGroup,
  eeoJobCategory,
  jobFamily,
  careerLevel,
  userDefinedFields,
  agingCode,
  isSlotted,
  salaryRangeMin,
  salaryRangeMid,
  salaryRangeMax
) {
  return async dispatch => {
    const isNewJob = orgJobId === null;
    try {
      dispatch({ type: SAVE_ORG_JOB_START });
      const jobDetails = {};

      const parsedYearsOfExperience = parseInt(yearsOfExperience);
      if (!isNaN(parsedYearsOfExperience)) {
        jobDetails.YearsExperience = parsedYearsOfExperience;
      }

      if (skills) {
        jobDetails.Skills = skills;
      }

      if (certs) {
        jobDetails.Certifications = certs;
      }

      const requestBody = {
        orgJobId,
        orgJobTitle: jobTitle,
        orgJobCode,
        currency,
        org_salary_structure: salaryStructure,
        org_salary_grade: salaryGrade,
        jobDetails,
        targetTotalCash,
        targetBaseSalary,
        targetTotalTargetCash,
        targetTotalGuaranteedPay,
        targetTotalDirect,
        userDefinedFields,
        jobFamily,
        careerLevel,
        triggerSummariesUpdate: true,
        agingCode,
        isSlotted,
        skipJobCompFactors: true
      };

      if (salaryRangeMin) {
        requestBody.salaryRangeMin = parseFloat(salaryRangeMin);
      }
      if (salaryRangeMid) {
        requestBody.salaryRangeMid = parseFloat(salaryRangeMid);
      }
      if (salaryRangeMax) {
        requestBody.salaryRangeMax = parseFloat(salaryRangeMax);
      }

      if (orgJobCodeKey !== null && orgJobCodeKey !== undefined) {
        requestBody.orgJobCodeKey = orgJobCodeKey || ' ';
      }

      if (jobDescription !== null && jobDescription !== undefined) {
        requestBody.job_description = jobDescription;
      }

      if (flsaExempt !== null && flsaExempt !== undefined) {
        requestBody.flsaExempt = flsaExempt;
      }

      if (eeoJobGroup !== null && eeoJobGroup !== undefined) {
        requestBody.eeoJobGroup = eeoJobGroup;
      }

      if (eeoJobCategory !== null && eeoJobCategory !== undefined) {
        requestBody.eeoJobCategory = eeoJobCategory;
      }

      const result = await apiClient.apiPost('/api/hris/jobs/saveJob', requestBody);

      if (result.data.org_job_id || result.data.showGroupFilterMessage) {
        if (isNewJob) {
          await this.copyAdhocJobMatchesToOrgJob(result.data.org_job_id, isSlotted);
        }
        dispatch({ type: SAVE_ORG_JOB_SUCCESS, orgJobId: result.data.org_job_id });

        return { id: result.data.org_job_id, showGroupFilterMessage: result.data.showGroupFilterMessage };
      } else {
        dispatch({ type: SAVE_ORG_JOB_FAILED, isDuplicateError: result.data.reason === 'DUPLICATE' });
      }
    } catch (error) {
      console.log(error);
      dispatch({ type: SAVE_ORG_JOB_FAILED });
    }
  };
}

export function getSalaryRanges(currency) {
  return async dispatch => {
    try {
      dispatch({ type: GET_SALARY_RANGES_START });
      const result = await apiClient.apiGet('/api/hris/grades/getSalaryStructure', {
        params: {
          currency,
          showNullMidpoint: true
        }
      });
      if (result.data.structure_list) {
        dispatch({ type: GET_SALARY_RANGES_SUCCESS, salaryRanges: result.data.structure_list });
      }
    } catch (error) {
      dispatch({ type: GET_SALARY_RANGES_ERROR });
      console.log(error);
    }
  };
}

export function copyAdhocJobMatchesToOrgJob(orgJobId, isSlotted) {
  return async dispatch => {
    try {
      const result = await apiClient.apiPost('/api/market-pricing/job-matches/copyJobMatches', {
        source_org_job_id: 0,
        org_job_id: orgJobId,
        copyParticipation: true,
        copyPayScalePublisher: true,
        isSlotted
      });
    } catch (error) {
      console.log(error);
      throw error;
    }
  };
}

export function setOrgJobCode(orgJobCode) {
  return { type: SET_ORG_JOB_CODE, orgJobCode };
}

export function setJobDescription(jobDescription) {
  return { type: SET_JOB_DESCRIPTION, jobDescription };
}

export function setCurrency(currency) {
  return { type: SET_CURRENCY, currency };
}

export function setSalaryRange(salaryRange) {
  return { type: SET_SALARY_RANGE, salaryRange };
}

export function setCareerLevel(careerLevel) {
  return { type: SET_CAREER_LEVEL, careerLevel };
}

export function setJobFamily(jobFamily) {
  return { type: SET_JOB_FAMILY, jobFamily };
}

export function setJobTitle(jobTitle) {
  return { type: SET_JOB_TITLE, jobTitle };
}

export function setYearsOfExperience(yearsOfExperience) {
  return { type: SET_YEARS_OF_EXPERIENCE, yearsOfExperience };
}

export function setTargetBaseSalary(targetBaseSalary) {
  return { type: SET_TARGET_BASE_SALARY, targetBaseSalary };
}

export function setTargetTotalCash(targetTotalCash) {
  return { type: SET_TARGET_TOTAL_CASH, targetTotalCash };
}

export function setTargetTotalTargetCash(targetTotalTargetCash) {
  return { type: SET_TARGET_TOTAL_TARGET_CASH, targetTotalTargetCash };
}

export function setTargetTotalGuaranteedPay(targetTotalGuaranteedPay) {
  return { type: SET_TARGET_TOTAL_GUARANTEED_PAY, targetTotalGuaranteedPay };
}

export function setTargetTotalDirect(targetTotalDirect) {
  return { type: SET_TARGET_TOTAL_DIRECT, targetTotalDirect };
}

export function setFLSAExempt(flsaExempt) {
  return { type: SET_FLSA_EXEMPT, flsaExempt };
}

export function setEEOJobGroup(eeoJobGroup) {
  return { type: SET_EEO_JOB_GROUP, eeoJobGroup };
}

export function setEEOJobCategory(eeoJobCategory) {
  return { type: SET_EEO_JOB_CATEGORY, eeoJobCategory };
}

export function resetSaveJobPricingToInitialState() {
  return { type: RESET_SAVE_JOB_PRICING_TO_INITIAL_STATE };
}

export function setOrgJobCodeKey(orgJobCodeKey) {
  return { type: SET_ORG_JOB_CODE_KEY, orgJobCodeKey };
}

export function setOrgJobDetails(orgJobDetails) {
  return { type: SET_ORG_JOB_DETAILS, orgJobDetails };
}

export function setSelectedUserDefinedFields(userDefinedFields) {
  return { type: SET_SELECTED_USER_DEFINED_FIELDS, userDefinedFields };
}

export function setSalaryRangeMin(salaryRangeMin) {
  return { type: SET_SALARY_RANGE_MIN, salaryRangeMin };
}

export function setSalaryRangeMid(salaryRangeMid) {
  return { type: SET_SALARY_RANGE_MID, salaryRangeMid };
}

export function setSalaryRangeMax(salaryRangeMax) {
  return { type: SET_SALARY_RANGE_MAX, salaryRangeMax };
}
